<script setup>
import { computed, defineProps } from "vue";
import { useWindowSize } from "@vueuse/core";
import LayoutSidebar from "./components/LayoutSidebar.vue";
import LayoutTopbar from "./components/LayoutTopbar.vue";
import V4HomeAnnouncement from "@/components/v4/home/announcement/V4HomeAnnouncement.vue";
import { ElBacktop } from "element-plus";
import V4UpcomingEventModal from "@/components/v4/home/event/V4UpcomingEventModal.vue";

const props = defineProps({
  showChrome: {
    type: Boolean,
    default: true,
  },
});

const { width } = useWindowSize();

const backtopOffset = computed(() => (width.value < 640 ? 20 : 90));
</script>

<template>
  <div class="min-h-screen w-full flex flex-col bg-white">
    <V4HomeAnnouncement v-if="props.showChrome" />
    <div class="flex-1 flex items-start">
      <LayoutSidebar v-if="props.showChrome" />

      <div class="flex-1 flex flex-col min-w-0">
        <LayoutTopbar v-if="props.showChrome" />

        <slot />
      </div>
    </div>
    <V4UpcomingEventModal v-if="props.showChrome" />
    <ElBacktop
      v-if="props.showChrome"
      :right="backtopOffset"
      :bottom="backtopOffset"
    />
  </div>
</template>

<style scoped>
.no-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
</style>
